<template>
  <div class="lawdettyls">
    <sub-title text="特邀律师" />
    <div class="cardlist">
      <law-card class="tyitem" />
      <law-card class="tyitem" />
      <law-card class="tyitem" />
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
import lawCard from "views/laws/components/lawCard";
export default {
  components: {
    subTitle,
    lawCard,
  },
};
</script>

<style lang="scss" scoped>
.lawdettyls {
  padding: 22px 12px;
  .cardlist {
    padding: 10px 0;
    .tyitem {
      margin-top: 16px;
    }
  }
}
</style>